import axios from "axios";
const api = axios.create({
  // baseURL: "/api/",
  // baseURL: "https://Livedhere.gov.eg/api/",
  // baseURL: "http://41.128.217.181:10067/api/api/",
  baseURL: "/api/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

// api.get("")
//         .then((response)=> console.log("try response",response))
//         .catch((err)=>console.log("try err",err))

// api.post("",
//         {data:"hfia"},
//         { headers: { Authorization: 'Bearer token123' } }
//         )
//             .then((response)=> console.log("try response",response))
//             .catch((err)=>console.log("try err",err))
// =================================================================================================

// Home page
export const addedRecentlyCall = (count) => {
  return api
    .get(`Character/RecentlyAddedCharacters?count=${count}`)
    .then((response) => {
      console.log("addedRecentlyCall axiosApis", response.data);
      return response.data;
    })
    .catch((err) => console.log("addedRecently", err));
};
export const characterSliderCall = (count) => {
  return api
    .get(`Character/GetCharactersForSlider?count=${count}`)
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("CharacterSliderCall", err));
};

// NEWSSSS  +++++
export const latestNewsCall = () => {
  return api
    .get("News/latest")
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("latestNewsCall", err));
};

export const allNewsCall = () => {
  return api
    .get("News/all")
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("allNewsCall", err));
};

export const newsByIdCall = (id) => {
  return api
    .get(`News/GetNewsById?id=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => console.log("newsByIdCall", err));
};

// Videos
export const allVideosCall = () => {
  return api
    .get("Videos")
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("allVideosCall", err));
};

// statistics

export const allStasCall = () => {
  return api
    .get("Statistics")
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("allStasCall", err));
};

// Characters page
export const mostSearchedCall = (num) => {
  return api
    .get(`Character/MostSearched?topCount=${num}`)
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("mostSearchedCall", err));
};

export const charByLetterCall = (seachName, isArabic = true) => {
  let queryParamter = "";
  if (seachName) {
    queryParamter = "?name=" + seachName;
  } else {
    queryParamter = "";
  }
  const endpoint = isArabic
    ? `Character/GroupedByLetters${queryParamter}`
    : `Character/GroupedByEngLetters${queryParamter}`;
  return api
    .get(endpoint)
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("charByLetterCall", err));
};

export const charByIdCall = (id) => {
  return api
    .get(`Character/${id}`)
    .then((response) => {
      // console.log("try response",response)
      return response.data;
    })
    .catch((err) => console.log("charByIdCall", err));
};

// Fields
export const charByFieldCall = (searchQuery, fieldId, specialityId) => {
  console.log("we are here");
  console.log(
    "we are here charByFieldCall",
    fieldId,
    specialityId,
    searchQuery,
  );
  let queryParamter = "";
  if (searchQuery && fieldId && specialityId) {
    console.log("we are hereeee", fieldId, specialityId, searchQuery);
    // queryParamter = "?searchQuery="+searchQuery
    queryParamter = `?fieldId=${fieldId}&specialityId=${specialityId}&searchQuery=${searchQuery}`;
  } else if (fieldId && specialityId) {
    console.log("we are hereee", fieldId, specialityId, searchQuery);

    queryParamter = `?fieldId=${fieldId}&specialityId=${specialityId}`;
  } else if (fieldId && searchQuery) {
    console.log(
      "we are hereee fieldId and searchQuery",
      fieldId,
      specialityId,
      searchQuery,
    );

    queryParamter = `?fieldId=${fieldId}&searchQuery=${searchQuery}`;
  } else if (specialityId && searchQuery) {
    console.log(
      "we are hereee specialityId and searchQuery",
      fieldId,
      specialityId,
      searchQuery,
    );

    queryParamter = `?specialityId=${specialityId}&searchQuery=${searchQuery}`;
  } else if (fieldId) {
    console.log("we are hereee fieldId", fieldId, specialityId, searchQuery);

    queryParamter = `?fieldId=${fieldId}`;
  } else if (specialityId) {
    console.log(
      "we are hereee specialityId",
      fieldId,
      specialityId,
      searchQuery,
    );

    queryParamter = `?specialityId=${specialityId}`;
  } else if (searchQuery) {
    console.log(
      "we are hereee searchQuery",
      fieldId,
      specialityId,
      searchQuery,
    );

    queryParamter = `?searchQuery=${searchQuery}`;
  } else {
    console.log("we are hereee", fieldId, specialityId, searchQuery);

    queryParamter = "";
  }
  // return api.get("Field/fields-with-characters")
  console.log("queryParamter", queryParamter);
  return api
    .get(`Specialties/CharactersOfSpeciality${queryParamter}`)
    .then((response) => {
      console.log("try response", response);
      return response.data;
    })
    .catch((err) => console.log("fieldByFieldCall", err));
};

export const mostcharByFieldCall = () => {
  return api
    .get("Specialties")
    .then((response) => {
      return response.data;
    })
    .catch((err) => console.log("mostcharByFieldCall", err));
};

export const CharByFieldCall_Speciality = (id) => {
  return api
    .get(`Specialties?fieldId=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => console.log("CharByFieldCall_Speciality", err));
};
